import DeleteIcon from "@mui/icons-material/Delete";
import {useAufgabenHandling} from "../../hooks/aufgaben/useAufgabenHandling";
import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import {
    Button,
    capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton
} from "@mui/material";

interface ButtonDeleteAufgabeProps {
    aufgabeId: string;
}

export default function ButtonDeleteAufgabe({aufgabeId}: ButtonDeleteAufgabeProps) {
    const {translation, deleteAufgabeMutation} = useAufgabenHandling();
    const popupState = usePopupState({
        variant: 'popover',
        popupId: `aufgabe-${aufgabeId}-delete`,
    });

    return (
        <>
            <IconButton id={`button-delete-aufgabe-${aufgabeId}`}
                        aria-label={`button-delete-aufgabe-${aufgabeId}`}
                        {...bindTrigger(popupState)}
            >
                <DeleteIcon/>
            </IconButton>
            <Dialog id={`dialog-delete-aufgabe-${aufgabeId}`}
                    {...bindPopover(popupState)}
            >
                <DialogTitle id={`dialog-title-delete-aufgabe-${aufgabeId}`}>
                    {capitalize(translation('delete-dialogue-title'))}
                </DialogTitle>
                <DialogContent id={`dialog-content-delete-aufgabe-${aufgabeId}`}>
                    <DialogContentText id={`dialog-content-text-delete-aufgabe-${aufgabeId}`}>
                        {capitalize(translation('delete-dialogue-description'))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id={`dialog-action-cancel-delete-aufgabe-${aufgabeId}`}
                            color={'inherit'}
                            onClick={() => popupState.close()}
                    >
                        {capitalize(translation('abort'))}
                    </Button>
                    <Button id={`dialog-action-confirm-delete-aufgabe-${aufgabeId}`}
                            color={'error'}
                            variant={'contained'}
                            onClick={() => {
                                deleteAufgabeMutation.mutate(aufgabeId);
                                popupState.close();
                            }}
                    >
                        {capitalize(translation('delete'))}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

